// Version : 1.0.0
// Author : AGALYA

import { makeApiCall } from '../../../_common/api.utils';
import { API_URL } from '../../../const';

/** ***************** Passport Update Start ************************/
export const passportUpdate = (updatePassportData: any) => {
	const data = {
		PassportToken: updatePassportData,
	};
	const url = `${API_URL}updatePassport`;
	return makeApiCall(url, data);
};
/** ***************** Passport Update End ************************/
